import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import {
  closeAllModals, openNewModal,
} from '~/store/modal/modal.actionCreators';

export const useMigrationProgressObserver = () => {
  const dispatch = useDispatch();
  const { status } = useSelector(state => state.mapMigration.migrationStatus);

  useEffect(() => {
    switch (status) {
      case 'IN_PROGRESS':
        dispatch(openNewModal('MigrationInProgress', undefined));
        break;
      case 'NONE':
        dispatch(closeAllModals());
        break;
      case 'FAILED':
      case 'SUCCESS':
        dispatch(closeAllModals());
        dispatch(openNewModal('MigrationFinished', undefined));
        break;
      default:
        throw new Error(`Unknown migration status: '${status}'.`);
    }
  }, [dispatch, status]);
};
